import {artTypes} from 'common/constant';
import cfg from 'common/config';
import Jt from "common/util/jt.js";
const Jt_B = Jt.base;

export function pathFormat(item) {
    const d = Jt_B.parseQueryString(window.location.href)['d'];
    let type = artTypes[item.type] || 'normal';
    if (item.type == '2' && item.category == '专题') {
      type = 'subject';
    } else {
      type = 'normal';
    }
    const isMessageFrom = item.messageFrom === 'zxb';
    // 资讯部的新闻会含有auditMongoId/originId/cardId，信息流只有cardId
    const cardId = item.auditMongoId || item.originId || item.cardId;
    // 如果来自资讯部且有auditMongoId值，则采用生成的id，如果只是来自资讯部则进行地址拼接，否则就正常使用生成的id
    const finalCardId = (isMessageFrom && item.auditMongoId)
                        ? cardId
                        : isMessageFrom 
                          ? ('ZXB-ORIGIN-' + cardId)
                          : cardId;
    const finalUrl = cfg.BASE_URL_PREFIX
                     + '/wap-news-mi-v2'
                     + '?type=normal&lang=cn'
                     + '&id=' + finalCardId
                     + '&cp=cn-renminwang&itemtype=news&docid=renminwang_' + finalCardId;
    console.log(finalUrl)
    return finalUrl
}




// WEBPACK FOOTER //
// ./src/common/router/helper.js